import { useSelector } from "react-redux";
import { Roles, normalizeRole } from "../config";


export const useCurrentBranch = () => {
  const { profileReducer, branchReducer } = useSelector(s => s);

  let currentBranch = { role: Roles.ADMINISTRATOR };
  let currentRole = null;
  let hasActiveSubscription = false; // Default to false, will be set from /full endpoint

  if (profileReducer.info && profileReducer.info.branches.length && branchReducer.info && branchReducer.info.id) {
    const found = profileReducer.info.branches.find(b => b.id === branchReducer.info.id);
    if (found) {
      currentRole = normalizeRole(found.role);
      currentBranch = { ...found, role: currentRole };
    } else {
      currentBranch = { role: Roles.ADMINISTRATOR };
      currentRole = Roles.ADMINISTRATOR;
    }
  }

  // Check subscription status from /full endpoint (branchReducer.info.subscription.is_active)
  if (branchReducer?.info?.subscription) {
    hasActiveSubscription = branchReducer.info.subscription.is_active === true;
    console.log('useCurrentBranch: subscription.is_active =', branchReducer.info.subscription.is_active);
  } else {
    console.log('useCurrentBranch: No subscription data available yet');
  }

  // Get WhatsApp provider configuration
  const whatsappProvider = branchReducer?.info?.configuration?.whatsapp_provider;

  return {
    currentBranch,
    currentRole,
    groupId: branchReducer?.info?.group_id,
    hasActiveSubscription,
    whatsappProvider
  };
}
